module.exports = __webpack_public_path__ + "img/task-done-02 1.5b728ea6.svg";